import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LandLordContext from "../../../context/landlord/LandLordContext";
import AuthContext from "../../../context/auth/AuthContext";
import { useSnackbar } from "material-ui-snackbar-provider";
import delicon from "../../../assets/img/del.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../../hooks/useTranslator";
import {
  convertCurrencyFormat,
  haveValue,
  getBaseUrl,
} from "../../../helper/common";
import { Modal, Row } from "react-bootstrap";
import LinkedPropertiesPopup from "../../../components/Property/LinkedPropertiesPopup";

const SingleProperty = ({
  property,
  number,
  onPropertyAward,
  tanentData,
  loadData,
  hideModal,
  setLinkedTenantsPopup,
}) => {
  const { _t } = useTranslator();

  const [show, setShow] = useState(false);
  const [propData, setPropData] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [deleteId, setDeleteId] = useState("");

  const showmodal = (propId) => {
    setDeleteId(propId);
    handleShow();
  };

  const {
    floor_number,
    street_number,
    street,
    flat_number,
    postcode,
    muncipality,
    province,
    staircase,
    area,
    property_reference = null,
  } = property;
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const navigate = useNavigate();
  const landLordContext = useContext(LandLordContext);
  const { deleteProperty, updatePropertyDetails, isParentLL } = landLordContext;

  const [awardConfirmationModal, setAwardConfirmationModal] = useState(false);

  const deleteMyProperty = (propertyid) => {
    console.log("this property has to be deleted", propertyid);
    deleteProperty(propertyid, user?._id);
  };

  const handleOpenDetails = (property) => {
    setPropData(property);
    setLinkedTenantsPopup(true);
  };

  const awardPropertyHandler = async () => {
    try {
      let propertyId = property._id.toString();
      await updatePropertyDetails(propertyId, {
        is_awarded: property.is_awarded === true ? false : true,
      });

      onPropertyAward(propertyId);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="text-left">
        <div className="properties-box remove_box_style">
          <div className="flex-row">
            {/* <h4>{_t("Property")} {number + 1}</h4> */}
            <div>
              <h4>
                {street} - {street_number}
              </h4>
            </div>
            <div className="d-flex align-items-center custom-gap_css">
              <Link onClick={() => showmodal(property._id)}>
                <img src={delicon} alt="" />
              </Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                style={{ cursor: "pointer" }}
                onClick={(e) => hideModal()}
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.7734 1.32064C16.8453 1.24881 16.9022 1.16352 16.9411 1.06966C16.98 0.975805 17 0.875207 17 0.773615C17 0.672022 16.98 0.571424 16.9411 0.477565C16.9022 0.383706 16.8453 0.298423 16.7734 0.226586C16.7016 0.15475 16.6163 0.0977657 16.5224 0.058888C16.4286 0.0200102 16.328 0 16.2264 0C16.1248 0 16.0242 0.0200102 15.9303 0.058888C15.8365 0.0977657 15.7512 0.15475 15.6794 0.226586L8.5 7.40749L1.32064 0.226586C1.24881 0.15475 1.16352 0.0977657 1.06966 0.058888C0.975805 0.0200102 0.875207 7.56923e-10 0.773615 0C0.672022 -7.56923e-10 0.571424 0.0200102 0.477565 0.058888C0.383706 0.0977657 0.298423 0.15475 0.226586 0.226586C0.15475 0.298423 0.0977657 0.383706 0.058888 0.477565C0.0200102 0.571424 -7.56923e-10 0.672022 0 0.773615C7.56923e-10 0.875207 0.0200102 0.975805 0.058888 1.06966C0.0977657 1.16352 0.15475 1.24881 0.226586 1.32064L7.40749 8.5L0.226586 15.6794C0.0815054 15.8244 0 16.0212 0 16.2264C0 16.4316 0.0815054 16.6283 0.226586 16.7734C0.371667 16.9185 0.568439 17 0.773615 17C0.97879 17 1.17556 16.9185 1.32064 16.7734L8.5 9.59251L15.6794 16.7734C15.8244 16.9185 16.0212 17 16.2264 17C16.4316 17 16.6283 16.9185 16.7734 16.7734C16.9185 16.6283 17 16.4316 17 16.2264C17 16.0212 16.9185 15.8244 16.7734 15.6794L9.59251 8.5L16.7734 1.32064Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
          {isParentLL && (
            <h6>
              {_t("LL")} - {property?.landlord?.fname_companyName}{" "}
              {property?.landlord?.lname}
            </h6>
          )}
          <div className="flex-content">
            <ul>
              <li>
                <span>{_t("street")}:</span>
                <span>{_t("number")}:</span>
              </li>
              <li>
                <span
                  className={`cl-text ${
                    haveValue(street) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(street) ? street : _t("noInfo")}
                </span>
                <span
                  className={`cl-text ${
                    haveValue(street_number) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(street_number) ? street_number : _t("noInfo")}
                </span>
              </li>
            </ul>
          </div>
          <div className="flex-content">
            <ul>
              <li>
                <span>{_t("stairway")}:</span>
                <span>{_t("floorNumber")}:</span>
              </li>
              <li>
                <span
                  className={`cl-text ${
                    haveValue(staircase) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(staircase) ? staircase : _t("noInfo")}
                </span>
                <span
                  className={`cl-text ${
                    haveValue(floor_number) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(floor_number) ? floor_number : _t("noInfo")}
                </span>
              </li>
            </ul>
          </div>
          <div className="flex-content">
            <ul>
              <li>
                <span>{_t("letter")}:</span>
                <span>{_t("municipality")}:</span>
              </li>
              <li>
                <span
                  className={`cl-text ${
                    haveValue(flat_number) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(flat_number) ? flat_number : _t("noInfo")}
                </span>
                <span
                  className={`cl-text ${
                    haveValue(muncipality) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(muncipality) ? muncipality : _t("noInfo")}
                </span>
              </li>
            </ul>
          </div>
          <div className="flex-content">
            <ul>
              <li>
                <span>{_t("postCode")}:</span>
                <span>{_t("province")}</span>
              </li>
              <li>
                <span
                  className={`cl-text ${
                    haveValue(postcode) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(postcode) ? postcode : _t("noInfo")}
                </span>
                <span
                  className={`cl-text ${
                    haveValue(province) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(province) ? province : _t("noInfo")}
                </span>
              </li>
            </ul>
          </div>
          <div className="flex-content d-flex justify-content-between align-items-start">
            <ul className="col-6">
              <li>
                <span>{_t("area")}:</span>
                <span>&nbsp;</span>
              </li>
              <li>
                <span
                  className={`cl-text ${
                    haveValue(area) ? "" : "setNoInfoText"
                  }`}
                >
                  {haveValue(area) ? area : _t("noInfo")}
                </span>
                <span>&nbsp;</span>
              </li>
            </ul>
            {user?._id.toString() ==
              process.env.REACT_APP_MACC_LANDLORED_ID && (
              <div className=" col-6">
                {(!property?.hasOwnProperty("is_awarded") ||
                  property?.is_awarded === false) && (
                  <button
                    className="mb-2 awarded-btn"
                    type="button"
                    onClick={() => {
                      setAwardConfirmationModal(true);
                    }}
                  >
                    {_t("markAsAwarded")}
                  </button>
                )}
                {(!property?.hasOwnProperty("is_awarded") ||
                  property?.is_awarded === true) && (
                  <button
                    className="mb-2 awarded-btn btn-gray"
                    type="button"
                    onClick={() => {
                      setAwardConfirmationModal(true);
                    }}
                  >
                    {/* <img
                    style={{ width: "1vw" }}
                    src="/images/Tick.svg"
                    alt=""
                  /> */}
                    {_t("unmarkAsAwarded")}
                  </button>
                )}
              </div>
            )}
          </div>

          {haveValue(property_reference) && (
            <div className="flex-content">
              <ul>
                <li className="property_details_100">
                  <span>{_t("propertyReference")}:</span>
                </li>
                <li className="property_details_100">
                  <span
                    className={`cl-text ${
                      haveValue(property_reference) ? "" : "setNoInfoText"
                    }`}
                  >
                    {haveValue(property_reference)
                      ? property_reference
                      : _t("noInfo")}
                  </span>
                </li>
              </ul>
            </div>
          )}
          <div
            className="d-flex justify-content-between linked_tenant_div"
            onClick={(e) => {
              handleOpenDetails(property);
              hideModal();
            }}
          >
            <div className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
              >
                <path
                  d="M13.5 4.21053C13.5 5.32723 13.0259 6.39819 12.182 7.18782C11.3381 7.97745 10.1935 8.42105 9 8.42105C7.80653 8.42105 6.66193 7.97745 5.81802 7.18782C4.97411 6.39819 4.5 5.32723 4.5 4.21053C4.5 3.09383 4.97411 2.02286 5.81802 1.23323C6.66193 0.443608 7.80653 0 9 0C10.1935 0 11.3381 0.443608 12.182 1.23323C13.0259 2.02286 13.5 3.09383 13.5 4.21053ZM13.1378 11.0558C12.6056 11.0611 12.1095 11.08 11.6775 11.1337C10.9541 11.2253 10.1621 11.4421 9.5085 12.0547C8.85375 12.6663 8.622 13.4074 8.52525 14.0842C8.4375 14.6926 8.4375 15.4358 8.4375 16.2253V16.4063C8.4375 17.1958 8.4375 17.9389 8.52525 18.5474C8.59275 19.0221 8.72775 19.5284 9.02812 20H9C0 20 0 17.8789 0 15.2632C0 12.6474 4.02975 10.5263 9 10.5263C10.4917 10.5263 11.8991 10.7168 13.1378 11.0558Z"
                  fill="#253837"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.0625 20C12.2062 20 11.2781 20 10.7021 19.46C10.125 18.9211 10.125 18.0526 10.125 16.3158C10.125 14.579 10.125 13.7105 10.7021 13.1716C11.2781 12.6316 12.2062 12.6316 14.0625 12.6316C15.9187 12.6316 16.8469 12.6316 17.4229 13.1716C18 13.7105 18 14.579 18 16.3158C18 18.0526 18 18.9211 17.4229 19.46C16.8469 20 15.9187 20 14.0625 20ZM16.2765 15.5221C16.3996 15.407 16.4687 15.2508 16.4687 15.0879C16.4687 14.925 16.3996 14.7689 16.2765 14.6537C16.1534 14.5385 15.9865 14.4738 15.8124 14.4738C15.6384 14.4738 15.4715 14.5385 15.3484 14.6537L13.1884 16.6747L12.7766 16.2905C12.7157 16.2335 12.6433 16.1883 12.5637 16.1574C12.4841 16.1266 12.3987 16.1107 12.3126 16.1107C12.2264 16.1107 12.141 16.1266 12.0614 16.1574C11.9818 16.1883 11.9094 16.2335 11.8485 16.2905C11.7876 16.3476 11.7392 16.4153 11.7062 16.4898C11.6733 16.5643 11.6563 16.6441 11.6563 16.7248C11.6563 16.8054 11.6733 16.8852 11.7062 16.9597C11.7392 17.0342 11.7876 17.1019 11.8485 17.159L12.7238 17.9779C12.7847 18.035 12.857 18.0802 12.9366 18.1111C13.0163 18.142 13.1016 18.1579 13.1878 18.1579C13.274 18.1579 13.3594 18.142 13.439 18.1111C13.5186 18.0802 13.591 18.035 13.6519 17.9779L16.2765 15.5221Z"
                  fill="#253837"
                />
              </svg>
              <p className="linked_p">
                {_t("linkedTo")} {property.sharedProfiles.length || 0}
              </p>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="15"
                viewBox="0 0 9 15"
                fill="none"
              >
                <path
                  d="M1 14L8 7.5L1 1"
                  stroke="#121212"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} className="metermodal " centered onHide={handleClose}>
        <Modal.Body>
          <h4>
            {_t(
              "areYouSureYouWantToDeleteThisPropertyPleaseNoteThatThisActionCannotBeUndone"
            )}
          </h4>
          <div className="auth-form">
            <div className="btngroup row100 gridbar">
              <button
                className="btn btnoutline"
                type="button"
                onClick={(e) => {
                  handleClose();
                }}
              >
                {_t("no")}
              </button>
              <button
                className="btn btngreen"
                onClick={(e) => deleteMyProperty(deleteId)}
              >
                {_t("yes")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={awardConfirmationModal}
        className="metermodal "
        centered
        onHide={() => {
          setAwardConfirmationModal(false);
        }}
      >
        <Modal.Body>
          <h4>{_t("areYouSure")}</h4>
          <div className="auth-form">
            <div className="btngroup row100 gridbar">
              <button
                className="btn btnoutline"
                type="button"
                onClick={() => {
                  setAwardConfirmationModal(false);
                }}
              >
                {_t("no")}
              </button>
              <button
                className="btn btngreen"
                onClick={(e) => awardPropertyHandler()}
              >
                {_t("yes")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SingleProperty;
